import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BinService {
  // Seed from sessionStorage so a page refresh works immediately
  private binSubject = new BehaviorSubject<string>(
    (sessionStorage.getItem('bin_number') || '').trim()
  );

  bin$ = this.binSubject.asObservable();

  /** Call this wherever the BIN first becomes known (login/profile callback). */
  setBin(bin: string): void {
    const clean = (bin || '').trim();
    sessionStorage.setItem('bin_number', clean);
    this.binSubject.next(clean);   // notifies every component waiting on bin$
  }

  getBin(): string {
    return (this.binSubject.value || '').trim();
  }
}